module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "ch02"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/OEBPS/Text/pppstrangers005#toc"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Somewhere in St. Augustine, Florida, right this minute, someone is murdering history. It happens all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("When this city was founded, Elizabeth I was Queen of England. It was a single year after the death of Michelangelo, and the Renaissance had seized Europe with no intention of letting go. In other words, it was a very long time ago.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Since then, the Spanish built their city atop the site of a Native American village. Then the English came and went, and the Spanish came back. And now the Americans have held the land for nearly two centuries.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("In St. Augustine, it is possible to drop your car keys and destroy something irreplaceable. Actually putting a shovel or a bulldozer blade into the soil…well, such activities are highly regulated.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Some people resent being told what to do. And some people are capable of doing bad things…evil things…when they have dollar signs in their eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Somewhere in the countryside outside the old city, a bulldozer is scraping away the topsoil to build an upscale development. A human finger bone, a broken war club, a few musket balls, two pieces of a long stone blade, a corroded crucifix, a scattering of silver rosary beads, and a startling amount of very old trash—the discovery of these things causes the developer a moment of consternation, but only a moment. They are quickly discarded.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The man in charge has just one thing to say.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“What the historic preservation people don’t know won’t hurt ’em.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-573bbecf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/ppp-strangers010.vue
// module id = 84
// module chunks = 0